<template>
    <UiModal :class="css.container" ref="modal" spacing="40px 68px">
        <!-- * 标题 -->
        <div class="font-variable font-bold color-1" :class="css.header">{{ $t("GeneSearch") }}</div>

        <!-- * 内容 -->
        <div :class="css.body" v-loading="loading">
            <!-- * 搜索窗口 -->
            <div :class="css.search">
                <UiInput
                    ref="input"
                    v-model="keyword"
                    width="100%"
                    :maxlength="1024"
                    :placeholder="$t('Placeholder.SearchGeneOrID', 2)"
                    @enter="() => methods.search(1)" />
                <div :class="css.icon" @click="() => methods.search(1)">
                    <UiIcon name="search" />
                </div>
            </div>

            <!-- * 提示语 -->
            <div :class="css.controls">
                <div :class="css.placeholder">
                    <template v-if="!keyword_cache">{{ $t("SearchPlaceholder") }}</template>
                    <i18n-t v-else scope="global" keypath="SearchTypeResult">
                        <template v-slot:type>{{ $t("Gene") }}</template>
                        <template v-slot:number>{{ count }}</template>
                        <template v-slot:keyword>
                            <span>{{ keyword_cache }}</span>
                        </template>
                    </i18n-t>
                </div>

                <div :class="css.selector" v-if="!selector?.length">
                    <div :class="css.name" class="font-bold color-1">{{ $t("FilterBySpecies") }}</div>
                    <ui-select v-model="select" :width="200" :z-index="666" :candidates="options.seletcor" @change="methods.search(1)" />
                </div>
            </div>

            <template v-if="data.length">
                <!-- * 数据表格 -->
                <div :class="css.table">
                    <UiTable2 :option="options.table" :data="data" @radio="methods.select" selector="radio">
                        <template #alias="{ data }">
                            <div v-html="data.alias"></div>
                        </template>
                        <template #source="{ data }">
                            <div :class="css.source">
                                <UiIcon :name="useSpeciesIconKey(data.taxonomy_id)" />
                                <div>{{ data.taxonomy_name }}</div>
                            </div>
                        </template>
                    </UiTable2>
                </div>

                <!-- * 分页器 -->
                <UiPagination :class="css.pagination" :count="count" :items="false" :limit="10" v-model="page" @change="() => methods.search()" />
            </template>
        </div>
    </UiModal>
</template>

<script lang="ts" setup>
//* 组件库
import { UiTable2, UiSelect, UiModal, UiInput, UiIcon, UiPagination } from "various-ui";
//* 组件属性
import { SearchGeneEmits, SearchGenePropsOption } from "./src";
import { useComposable } from "./src/composable";
//* 样式
import css from "./style/index.module.less";

//* 组件属性注册
const define = defineProps(SearchGenePropsOption);
const emits = defineEmits(SearchGeneEmits);

//* 组合函数
const { refs, nodes, methods, options } = useComposable(define, emits);
const { data, page, count, select, loading, keyword, keyword_cache } = refs;
const { modal, input } = nodes;
const { open } = methods;

//* 组件属性导出
defineExpose({ open });
</script>
